
import.meta.glob([ '../images/**', ])

import { createApp } from 'vue';

import CookieComply from './components/multilang/CookieComply.vue';
import Map from './components/Map.vue';
import ImgModal from './components/ImgModal.vue';

const cookieComplyElement = document.getElementById('cookie-comply');

if (cookieComplyElement) {
    const companyName = cookieComplyElement.dataset.companyName;
    const privacyPolicyUrl = cookieComplyElement.dataset.privacyPolicyUrl;
    const language = cookieComplyElement.dataset.language;
    
    const cookie = createApp(CookieComply, {
        companyName,
        privacyPolicyUrl,
        language
    });
    cookie.mount('#cookie-comply');
}

const mapElement = document.getElementById('map');

if(mapElement) {
    import('leaflet/dist/leaflet.css');
    
    const markers = mapElement.dataset.markers;
    const errors = mapElement.dataset.errors;
    const zoom = mapElement.dataset.zoom;
    const defaultColor  = mapElement.dataset.defaultColor ;
    
    const osmMAP = createApp(Map, {
        markers,
        errors,
        zoom,
        defaultColor
    });
    osmMAP.mount('#map');
}

const imgModalElement = document.getElementById('img-modal');
const carousel = document.getElementById('carouselExampleIndicators');

import('bootstrap').then(({ Carousel }) => {
    if(carousel) {
        new Carousel(carousel, {
            interval: 2500,
            ride: 'carousel'
        });
    }
}).catch(error => console.error('Błąd ładowania Bootstrapa:', error)); 
        

if (imgModalElement) {
    import('bootstrap-vue-next').then((module) => {
        const { createBootstrap } = module;

        const imgModal = createApp(ImgModal);
        imgModal.use(createBootstrap());
        
        imgModal.mount('#img-modal');
    });
}
